/**
 * @method combineDocuments
 * @param documentsA first array of documents
 * @param documentsB second array of documents
 *
 * if any items in `documentsB` do not exist in `documentsA`, add them.
 * compares the elements (objects) on the `id` key
 */
export const combineDocuments = function combineDocuments() {
  let documentsA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let documentsB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const result = [...documentsA]; // start with existing `documentsA` array

  documentsB.forEach(bDoc => {
    const hasMatch = documentsA.some(aDoc => aDoc.id && bDoc.id && aDoc.id === bDoc.id);

    // add the document if we **do not** have a match
    if (!hasMatch) {
      result.push(bDoc);
    }
  });
  return result;
};

/**
 * @method reduceDocuments
 * @param documentsA first array of documents
 * @param documentsB second array of documents
 *
 * if any documents in the second array (documentsB) exist in the first array (documentsA)
 * add them to the return value (will be assigned as the "new documentsA").
 * compares the documents (objects) on the `id` key
 */
export const reduceDocuments = function reduceDocuments() {
  let documentsA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let documentsB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const result = []; // start with empty array

  documentsB.forEach(bDoc => {
    const hasMatch = documentsA.some(aDoc => aDoc.id && bDoc.id && aDoc.id === bDoc.id);

    // add the document to the results if we **do** have a match
    if (hasMatch) {
      result.push(bDoc);
    }
  });
  return result;
};